/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';
import Category from 'app/components/Queue/Category.jsx';
import { HexColorPicker } from 'react-colorful';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as _ from 'underscore';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import DayPicker from 'app/components/common/DayPicker.jsx';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { compose } from 'redux';

const defaultColors = [
    '#af2613',
    '#98D563',
    '#1278c0',
    '#795ab1',
    '#e95a46',
    '#4ac56d',
    '#0b5991',
    '#f282e4',
    '#fdaa4a',
    '#179465',
    '#07385b',
    '#808080',
    '#f1d52f',
    '#40a2a6',
    '#272c70',
    '#000000'
];

const timeOptions = [
    {label: '12:00 a.m.', value: '00:00'},
    {label: '01:00 a.m.', value: '01:00'},
    {label: '02:00 a.m.', value: '02:00'},
    {label: '03:00 a.m.', value: '03:00'},
    {label: '04:00 a.m.', value: '04:00'},
    {label: '05:00 a.m.', value: '05:00'},
    {label: '06:00 a.m.', value: '06:00'},
    {label: '07:00 a.m.', value: '07:00'},
    {label: '08:00 a.m.', value: '08:00'},
    {label: '09:00 a.m.', value: '09:00'},
    {label: '10:00 a.m.', value: '10:00'},
    {label: '11:00 a.m.', value: '11:00'},
    {label: '12:00 p.m.', value: '12:00'},
    {label: '01:00 p.m.', value: '13:00'},
    {label: '02:00 p.m.', value: '14:00'},
    {label: '03:00 p.m.', value: '15:00'},
    {label: '04:00 p.m.', value: '16:00'},
    {label: '05:00 p.m.', value: '17:00'},
    {label: '06:00 p.m.', value: '18:00'},
    {label: '07:00 p.m.', value: '19:00'},
    {label: '08:00 p.m.', value: '20:00'},
    {label: '09:00 p.m.', value: '21:00'},
    {label: '10:00 p.m.', value: '22:00'},
    {label: '11:00 p.m.', value: '23:00'}
];

// what to say when a request fails without validation messages to show
const failureMessages = {
    CATEGORY_LIST: "We couldn't load your categories. Please try again.",
    CATEGORY_CREATE: "We couldn't save your category. Please try again.",
    CATEGORY_UPDATE: "We couldn't save your category. Please try again.",
    CATEGORY_DELETE: "We couldn't delete your category. Please try again."
};

class CategoryManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showNewColorPicker: false,
            autoSchedule: true,
            newCategory: {
                color: defaultColors[this.props.categories.length % 16],
                name: '',
                scheduleWindow: ['08:00', '17:00'],
                days: 0x7f
            },
            error: null
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.showNewColorPicker = this.showNewColorPicker.bind(this);
        this.createCategory = this.createCategory.bind(this);
        this.editCategory = this.editCategory.bind(this);
        this.deleteCategory = this.deleteCategory.bind(this);
        this.handleColorPicker = this.handleColorPicker.bind(this);
        this.setValidationError = this.setValidationError.bind(this);
        this.onShowUpgrade = this.onShowUpgrade.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyup = this.onKeyup.bind(this);
        this.toggleAutoSchedule = this.toggleAutoSchedule.bind(this);
        this.setDays = this.setDays.bind(this);
        this.setTimeRange = this.setTimeRange.bind(this);

    }

    categoryEmptyError() {
        return {
            errors: {
                validation: {
                    name: 'A category name is required'
                }
            }
        };
    }

    static getDerivedStateFromProps(props, state) {

        for (let type of Object.keys(failureMessages)) {
            let error = props.getApiErrors([type]);

            if (error.length) {
                return {
                    error: Object.assign({failure: failureMessages[type]}, error[0])
                };
            }
        }

        return null;
    }

    componentDidMount() {

        this.props.getCategories();

    }

    componentDidUpdate(prevProps, prevState) {

        // a new category was created - reset the category
        if (prevProps.categories.length < this.props.categories.length) {
            this.setState({
                newCategory: {
                    name: '',
                    color: defaultColors[this.props.categories.length % 16],
                    scheduleWindow: ['08:00', '17:00'],
                    days: this.state.newCategory.days
                }
            });
        }

    }

    showNewColorPicker() {
        let showNewColorPicker = ~this.state.showNewColorPicker;

        this.setState({
            showNewColorPicker
        });

    }

    createCategory() {
        let category = _.clone(this.state.newCategory);

        if (category.name === '') {
            this.setState({
                error: this.categoryEmptyError()
            });
            return;
        }

        if (!this.state.autoSchedule) {
            category.scheduleWindow = [];
            category.days = 0;
        } else {
            if (this.state.newCategory.scheduleWindow[0] == this.state.newCategory.scheduleWindow[1]) {
                this.setState({
                    error: {
                        errors: {
                            validation: {
                                schedule: 'Please choose two different times for your schedule'
                            }
                        }
                    }
                });
                return;
            }
        }

        this.props.createCategory(category);

        this.setState({
            error: null
        });

    }

    editCategory(category) {

        if (category.name === '') {
            this.setState({
                error: this.categoryEmptyError()
            });
            return;
        }

        this.props.updateCategory(category);

        this.setState({
            error: null
        });

    }

    deleteCategory(id) {

        let cancelAction = () => {
				this.props.closeAllModals();
			},
			confirmAction = (e) => {
				e.preventDefault();
				this.props.deleteCategory(id);
				this.props.closeAllModals();
				// page redirect handled by Automate.jsx _onRouteChange
			},
			modal = (
				<DeleteModal
					modalCopy="Are you sure you want to remove this category? All schedules and content associated with this category will also be removed."
					cancelAction={cancelAction}
					confirmAction={confirmAction} />
			);

        this.props.addModal(modal);

    }

    onInputChange(e) {

        let value = e.currentTarget.value,
            error = this.state.error;

        if (value !== '') {
            error = null;
        }

        FormUtilityMixin.requestChange.apply(this, [e]);

        this.setState({
            error
        });

    }

    handleColorPicker(color) {
        let newCategory = this.state.newCategory;

        newCategory.color = color;

        this.setState({
            newCategory
        });
    }

    setValidationError(newError) {
        let error = this.state.error;

        if (newError && error === null) {
            error = this.categoryEmptyError();
            this.setState({
                error
            });
        } else if (!newError && error !== null) {
            this.setState({
                error: null
            });
        }

    }

    onShowUpgrade(e) {

        e.preventDefault();

        this.props.showUpgradeModal(this.props.closeAllModals, 'category');

    }

    onFocus(e) {
        window.addEventListener('keyup', this.onKeyup);
    }

    onBlur(e) {
        window.removeEventListener('keyup', this.onKeyup);
    }

    onKeyup(e) {
        if (e.keyCode === 13) {
            this.createCategory();
        }
    }

    toggleAutoSchedule(e) {

        let autoSchedule = this.state.autoSchedule;

        this.setState({
            autoSchedule: e.currentTarget.checked
        });

    }

    setDays(e) {
        let newCategory = this.state.newCategory,
            days = newCategory.days,
            day = parseInt(e.currentTarget.dataset.day);

        if (day & days) {
            days = days ^ day;
        } else {
            days = days | day;
        }

        newCategory.days = days;

        this.setState({
            newCategory
        });
    }

    setTimeRange(e) {

        let field = e.currentTarget.dataset.field,
            newCategory = this.state.newCategory,
            index = 0;

        if (field === 'endTime') {
            index = 1;
        }

        newCategory.scheduleWindow[index] = e.currentTarget.value;

        this.setState({
            newCategory
        });

    }

    render() {
        let main = null,
            colorPicker = null,
            error = null,
            errors = [],
            constants = this.props.app.config.constants,
            upgradeAction = null,
            userHasAccess = (this.props.user.perms.resources && !this.props.user.perms.resources.categories) ? false : true;

        if (!userHasAccess) {
            upgradeAction = this.onShowUpgrade;
        }

        if (this.props.app.loading.CATEGORY_LIST) {
            main = (
                <Loading />
            );
        } else if (this.props.categories.length <= 1 && !userHasAccess) {
            main = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="category" />
            );
        } else {
            if (this.state.showNewColorPicker) {
                colorPicker = (
                    <div className="popover">
                        <div className="picker-cover" onClick={this.showNewColorPicker} role='button' aria-label="show color picker"></div>
                        <HexColorPicker color={this.state.newCategory.color} className="new-color-picker" onChange={this.handleColorPicker}/>
                    </div>
                );
            }

            if (this.state.error !== null && Object.keys(this.state.error).length) {
                let validation = (this.state.error.errors && this.state.error.errors.validation) || {};

                for (let key in validation) {
                    errors.push(validation[key]);
                }
                if (!errors.length && this.state.error.failure) {
                    errors.push(this.state.error.failure);
                }
                error = (
                    <div className="category-error">
                        {errors.map((error, i) => {
                            return (
                                <p key={i}>{error}</p>
                            );
                        })}
                    </div>
                );
            }

            main = (
                <div className="category-wrapper">
                    <h2>Categories</h2>
                    <div className="new-category-control">
                        <div className="new-category-control-block">
                            {colorPicker}
                            <div className='default-color-block' style={{backgroundColor: this.state.newCategory.color}} onClick={(userHasAccess) ? this.showNewColorPicker : upgradeAction} role="button" aria-label="show color picker"></div>
                            <input
                                type="text"
                                className="text-input medium-inline"
                                value={this.state.newCategory.name}
                                placeholder="Category Name"
                                onChange={(userHasAccess) ? this.onInputChange : upgradeAction}
                                data-field="newCategory.name"
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}/>
                        </div>
                        <div className="auto-schedule-control-block">
                            <div className={(this.state.autoSchedule) ? "auto-schedule-toggle" : "auto-schedule-toggle disabled"}>
                                <input type="checkbox" checked={this.state.autoSchedule} onChange={(userHasAccess) ? this.toggleAutoSchedule : upgradeAction} aria-label="Auto-generate a schedule for this category in all of your socials"/> Auto-generate a schedule for this category in all of your socials
                            </div>
                            <div className="auto-schedule-controls">
                                <div className={"range-selectors" + ((this.state.autoSchedule) ? '' : ' disabled')}>
                                    <div className="control-label range">Post Once Between:</div>
                                    <StyledSelect
                                        options={timeOptions}
                                        value={(this.state.newCategory.scheduleWindow !== undefined) ? this.state.newCategory.scheduleWindow[0] : ''}
                                        onChange={(userHasAccess) ? this.setTimeRange : upgradeAction}
                                        selectClass={this.state.autoSchedule ? "range-selector" : 'range-selector disabled'}
                                        controlState={this.state.autoSchedule ? '' : 'disabled'}
                                        linkedField="startTime"
                                        ariaLabel="Earliest time"/>
                                    <span className="range-divider">-</span>
                                    <StyledSelect
                                        options={timeOptions}
                                        value={(this.state.newCategory.scheduleWindow !== undefined) ? this.state.newCategory.scheduleWindow[1] : ''}
                                        onChange={(userHasAccess) ? this.setTimeRange : upgradeAction}
                                        selectClass={this.state.autoSchedule ? "range-selector" : 'range-selector disabled'}
                                        controlState={this.state.autoSchedule ? '' : 'disabled'}
                                        linkedField="endTime"
                                        ariaLabel="Latest time"/>
                                </div>
                                <div className={"day-selectors" + ((this.state.autoSchedule) ? '' : ' disabled')}>
                                    <div className="control-label">On Days:</div>
                                    <DayPicker
                                        {...this.props}
                                        days={this.state.newCategory.days}
                                        setDays={(userHasAccess) ? this.setDays : upgradeAction}
                                        controlActive={this.state.autoSchedule} />
                                    </div>
                            </div>
                            <div className="new-category-button-wrapper">
                                <button className='btn-primary reverse active fixed new-category-button' onClick={(userHasAccess) ? this.createCategory : upgradeAction}>
                                    Create
                                </button>
                            </div>
                        </div>
                        <div className="new-category-control-block">

                        </div>
                        {error}
                    </div>
                    <div className="category-list-wrapper">
                        <h2>Your Categories</h2>
                        <div className='category-list clearfix'>
                            {this.props.categories.map((category) => {
                                return (
                                    <Category
                                        {...this.props}
                                        key={category.id}
                                        category={category}
                                        updateHandler={this.editCategory}
                                        deleteHandler={this.deleteCategory}
                                        setValidationError={this.setValidationError}
                                        upgradeAction={upgradeAction}
                                        userHasAccess={userHasAccess}/>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <Content
                {...this.props}
                header={null}
                main={main}/>
        );

    }
}

CategoryManager.propTypes = {

};

CategoryManager.defaultProps = {

};

const enhance = compose(
    ComponentWithContext,
    SubscriptionModule
);

export default enhance(CategoryManager);
